// removed by extract-text-webpack-plugin
module.exports = {"alertPopup":"styles__alertPopup__2euOb","List":"styles__List__274Xh"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Forms/ConsentForms/styles.css
// module id = 150
// module chunks = 0